/*!
 * Product Tabs v2 — tab switching.
 * No jQuery. Uses data-* attributes + ARIA, with keyboard support.
 */
(function () {
  'use strict';

  // Find every tab group on the page (supports multiple instances)
  const tablists = document.querySelectorAll('.ptv2-tabs[role="tablist"]');
  if (!tablists.length) return;

  tablists.forEach(initTabGroup);

  function initTabGroup(tablist) {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const panelsWrap = tablist.nextElementSibling;
    if (!panelsWrap || !panelsWrap.classList.contains('ptv2-panels')) return;

    const panels = Array.from(panelsWrap.querySelectorAll('[role="tabpanel"]'));

    // Click / tap — activate the clicked tab
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab));
    });

    // Keyboard — left/right arrows move between tabs,
    // Home/End jump to first/last. Matches WAI-ARIA tab pattern.
    tablist.addEventListener('keydown', (e) => {
      const currentIdx = tabs.indexOf(document.activeElement);
      if (currentIdx === -1) return;

      let targetIdx = null;
      switch (e.key) {
        case 'ArrowRight':
          targetIdx = (currentIdx + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          targetIdx = (currentIdx - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          targetIdx = 0;
          break;
        case 'End':
          targetIdx = tabs.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      tabs[targetIdx].focus();
      activate(tabs[targetIdx]);
    });

    function activate(tab) {
      const panelId = tab.getAttribute('aria-controls');
      const panel = panels.find((p) => p.id === panelId);
      if (!panel) return;

      // Deactivate all
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      panels.forEach((p) => {
        p.classList.remove('is-active');
        p.hidden = true;
      });

      // Activate the target
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      panel.classList.add('is-active');
      panel.hidden = false;
    }
  }
})();